<!--     
        { name: 'email',             label: 'E-mail', requerido: '*' }, 
        { name: 'contrasena',        label: 'Contraseña', requerido: '*' },        
        { name: 'rfc',               label: 'RFC', requerido: '*' },
        { name: 'razon_social',      label: 'Razón Social', requerido: '*' },
        { name: 'entidad_federativa',   label: 'Entidad Fedarativa', requerido: '' },
        { name: 'codigo_postal',     label: 'Código Postal', requerido: '*' },
        { name: 'nombre_contacto',   label: 'Nombre de Contacto', requerido: '*' },
        { name: 'telefono',          label: 'Teléfono Empresa', requerido: '*' }
-->
<div class="distributors-form">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <h2>Ficha de la Empresa</h2>

        <div class="field" *ngFor="let field of [
                 
            { name: 'rfc',               label: 'RFC', requerido: '*' },
            { name: 'nombre',      label: 'Razón Social', requerido: '*' },
            { name: 'entidad_federativa',   label: 'Entidad Fedarativa', requerido: '' },
            { name: 'codigo_postal',     label: 'Código Postal', requerido: '*' },
            { name: 'nombre_contacto',   label: 'Representador Legal', requerido: '*' },
            { name: 'telefono',          label: 'Teléfono Empresa', requerido: '*' }
            ]">

            <label [for]="field.name">{{ field.label }} {{ field.requerido }}</label>
            <input [id]="field.name" [name]="field.name" [type]="field.name.includes('correo') ? 'email' : 'text'"
                [formControlName]="field.name"
                [ngClass]="{'input-error':getControl(field.name).touched && getControl(field.name).invalid}" />

            <small class="error" *ngIf="getControl(field.name).touched && getControl(field.name).invalid">
                <span *ngIf="getControl(field.name)?.hasError('required')">
                    Campo es obligatorio
                </span>
                <span *ngIf="getControl(field.name)?.hasError('maxlength')">
                    Máximo {{getControl(field.name).getError('maxlength').requiredLength }} caracteres
                </span>
                <span *ngIf="getControl(field.name).hasError('pattern')">
                    {{ field.label }} inválido
                </span>
                <span *ngIf="getControl(field.name).hasError('email')">
                    Correo inválido
                </span>
            </small>

        </div>
        <!-- Botones -->
        <div class="buttons">
            <button type="button" class="btn btn-secondary" (click)="salir()">
                Salir
            </button>
            <button type="submit" class="btn btn-primary">
                Guardar
            </button>
        </div>

        <!--
            <button type="submit">Guardar</button>
        -->

    </form>
</div>
<p-toast></p-toast>